import { Button } from 'components/Button/Button';
import { Modal } from 'components/Modal/Modal';
import { Portal } from 'components/Portal/Portal';
import { useTranslation } from 'react-i18next';

type CompanySendWelcomeEmailModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onSend: () => void;
    loading?: boolean;
};

export const CompanySendWelcomeEmailModal: React.FC<CompanySendWelcomeEmailModalProps> = ({
    isOpen,
    onClose,
    onSend,
    loading = false,
}) => {
    const { t } = useTranslation('company');

    return (
        <Portal>
            <Modal isOpen={isOpen} onClose={onClose} maxWidth={600}>
                <div className="mb-6">
                    <div className="text-lg font-semibold text-zinc-700 mb-2">{t('sendWelcomeEmailModalTitle')}</div>
                    <div className="text-zinc-500 text-sm">{t('sendWelcomeEmailModalSubtitle')}</div>
                </div>
                <div className="flex justify-end gap-2">
                    <Button variant="outline" onClick={onClose} disabled={loading}>
                        {t('settings.cancelModalButton')}
                    </Button>
                    <Button onClick={onSend} disabled={loading}>
                        {loading ? t('sendingEmail') : t('confirmSendEmailButton')}
                    </Button>
                </div>
            </Modal>
        </Portal>
    );
};

